"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ["M7.99-.01c-4.42 0-8 3.58-8 8s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8zm1 13h-2v-2h2v2zm0-3h-2v-7h2v7z"];
//# sourceMappingURL=error.js.map